(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["libase-arrival-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('libase-arrival-estimate')) {
  customElements.define('libase-arrival-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.initialize() && !this.initializationObserver) {
        this.initializationObserver = new MutationObserver(() => this.initialize());
        this.initializationObserver.observe(this, {childList: true, subtree: true, characterData: true});
      }
    }
    initialize() {
      if (this.ready || !this.isConnected) return this.ready;
      const q = (name) => this.querySelector(`[data-arrival-${name}]`);
      const required = ['config', 'state', 'controls', 'fallback', 'region', 'output', 'dispatch', 'condition'];
      if (required.some(name => !q(name)) || !this.querySelector('.lae__result')) return false;
      let config;
      let variant;
      try {
        config = JSON.parse(q('config').textContent);
        variant = JSON.parse(q('state').textContent);
      } catch (_) { return false; }
      if (!config?.strings || !variant || typeof variant.status !== 'string') return false;
      this.config = config;
      this.variant = variant;
      this.q = q;
      this.ready = true;
      this.initializationObserver?.disconnect();
      this.initializationObserver = null;
      this.strings = this.config.strings;
      this.events = new AbortController();
      this.status = this.variant.status;
      this.q('controls').hidden = !this.config.confirmed;
      try {
        const saved = sessionStorage.getItem('libase-arrival-region');
        if (saved && Array.from(this.q('region').options).some((option) => option.value === saved)) this.q('region').value = saved;
      } catch (_) {}
      this.addEventListener('change', (event) => {
        if (event.target === this.q('region')) {
          try {sessionStorage.setItem('libase-arrival-region', event.target.value);} catch (_) {}
        }
        this.render();
      }, {signal:this.events.signal});
      if (this.hasAttribute('data-bundle-arrival')) {
        const root = this.closest('[data-libase-bundle-builder]');
        root?.addEventListener('libase:bundle-state', event => {
          this.setBundleState(event.detail?.deliveries);
        }, {signal:this.events.signal});
        const signal = this.events.signal;
        const syncSelection = () => {
          if (signal.aborted || !this.isConnected) return;
          const selection = window.__libaseBundleLayoutFix?.instances?.get(root)?.selection;
          if (selection) this.setBundleState(selection.map(choice => choice?.variant?.delivery));
        };
        syncSelection();
        queueMicrotask(syncSelection);
      }
      this.visibilityHandler = () => {if (!document.hidden) this.render();};
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.timer = setInterval(() => this.render(), 60000);
      this.render();
      return true;
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.events?.abort();
      this.initializationObserver?.disconnect();
      this.initializationObserver = null;
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.ready = false;
    }
    setBundleState(deliveries) {
      const states = Array.isArray(deliveries) ? deliveries.filter(state => state && typeof state.status === 'string') : [];
      const exceptional = states.filter(state => state.status !== 'ready');
      const state = exceptional.find(value => ['sold_out', 'unavailable', 'load_error'].includes(value.status)) || exceptional.find(value => ['manual', 'backorder'].includes(value.status)) || exceptional[0];
      const notes = [...new Set(exceptional.map(value => value.note).filter(Boolean))];
      this.setState({status: states.length < 2 ? 'unknown_stock' : state?.status || 'ready', note: notes.join(' / ')});
    }
    parseDate(text) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(String(text))) return null;
      const date = new Date(`${text}T00:00:00.000Z`);
      return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === text ? date : null;
    }
    tokyoNow() {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      return {date:`${values.year}-${values.month}-${values.day}`,hour:Number(values.hour)};
    }
    addDays(date, days) { return new Date(date.getTime() + days * 86400000); }
    interpolate(text, values) {
      return Object.entries(values).reduce((result, [key, value]) => result.split(`{${key}}`).join(String(value)), text || '');
    }
    format(date) {
      const nowYear = this.tokyoNow().date.slice(0, 4);
      const pattern = String(date.getUTCFullYear()) === nowYear ? this.strings.month_day_format : this.strings.year_format;
      return this.interpolate(pattern,{year:date.getUTCFullYear(),month:date.getUTCMonth()+1,day:date.getUTCDate(),weekday:this.strings.weekdays.split(',')[date.getUTCDay()]});
    }
    setState(state) {
      this.variant = state;
      this.status = state.status;
      const node = this.querySelector('[data-arrival-state]');
      if (node) node.textContent = JSON.stringify(state);
      this.render();
    }
    setPending() { this.setState({status: 'loading', note: ''}); }
    setError() { this.setState({status: 'load_error', note: ''}); }
    setUnavailable() { this.setState({status: 'unavailable', note: ''}); }
    setVariantFromHTML(html) {
      const node = html.getElementById(`LibaseArrivalState-${this.dataset.sectionId}`);
      if (!node) {this.setError();return;}
      try {this.setState(JSON.parse(node.textContent));} catch (_) {this.setError();}
    }
    message(key, literal) {
      const result = this.querySelector('.lae__result');
      result.dataset.state = key;
      this.q('output').textContent = literal || this.strings[key] || this.strings.settings_pending;
      this.q('dispatch').hidden = true;
      this.q('condition').hidden = true;
    }
    render() {
      if (!this.config || !this.q) return;
      const status = this.status || 'unknown_stock';
      if (!this.config.confirmed) {
        this.q('controls').hidden = true;
        this.q('fallback').hidden = false;
        this.q('fallback').textContent = status === 'ready' ? this.strings.fallback : ((['manual', 'backorder'].includes(status) ? this.variant.note : '') || this.strings[status] || this.strings.settings_pending);
        return;
      }
      this.q('fallback').hidden = true;
      this.q('controls').hidden = false;
      const now = this.tokyoNow();
      if (status !== 'ready') {this.message(status, ['manual', 'backorder'].includes(status) ? this.variant.note : ''); return;}
      const region = this.q('region');
      const group = region.selectedOptions[0]?.dataset.group;
      if (group === 'remote') {this.message('remote_note');return;}
      if (!region.value) {this.message('select');return;}
      const base = this.parseDate(now.date);
      if (!base) {this.message('settings_pending');return;}
      const transit = this.config.regions[group];
      const config = this.config;
      const numbers = [config.dispatchMin, config.dispatchMax, transit?.min, transit?.max];
      if (!transit || numbers.some((n) => !Number.isInteger(n) || n < 1 || n > 30) || config.dispatchMax < config.dispatchMin || transit.max < transit.min) {this.message('settings_pending');return;}
      const dispatchStart = this.addDays(base, config.dispatchMin - 1);
      const dispatchEnd = this.addDays(base, config.dispatchMax - 1);
      const earliest = this.addDays(dispatchStart, transit.min);
      const latest = this.addDays(dispatchEnd, transit.max);
      this.message('ready',this.interpolate(this.strings.range,{start:this.format(earliest),end:this.format(latest)}));
      this.q('dispatch').textContent = this.interpolate(this.strings.dispatch,{start:this.format(dispatchStart),end:this.format(dispatchEnd)});
      this.q('dispatch').hidden = false;
      const paidDate = `${base.getUTCMonth() + 1}/${base.getUTCDate()}`;
      const payLabel = this.interpolate(this.strings.today,{date:paidDate});
      this.q('condition').textContent = this.interpolate(this.strings.condition,{region:region.selectedOptions[0].textContent,payment:payLabel});
      this.q('condition').hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["libase-lp-benefit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('libase-lp-benefit')) {
    customElements.define('libase-lp-benefit', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.key = `libase-lp-benefit:${this.dataset.campaign}`;
        this.barTemplate = this.querySelector('[data-lp-bar-template]');
        this.deactivate();
        if (this.dataset.enabled !== 'true' || this.dataset.preview === 'true' || this.dataset.currency !== 'JPY' || !this.dataset.endpoint) return;
        try {
          this.endpoint = new URL(this.dataset.endpoint);
          if (this.endpoint.protocol !== 'https:' && !['localhost','127.0.0.1'].includes(this.endpoint.hostname)) return;
        } catch { return; }
        document.addEventListener('libase:lp-issued', event => { this.receive(event.detail); });
        document.addEventListener('visibilitychange', () => { if (!document.hidden) { this.tick(); this.refresh(); } });
        window.addEventListener('pageshow', event => { if (event.persisted) { this.deactivate(); this.refresh(); } });
        window.addEventListener('storage', event => { if (event.key === this.key) { this.deactivate(); this.refresh(); } });
        document.addEventListener('submit', event => {
          const button = event.submitter;
          if (button?.name !== 'checkout' || !this.isActive()) return;
          event.preventDefault();
          location.assign(this.checkoutUrl());
        }, true);
        document.addEventListener('click', event => {
          if (!this.isActive() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[href]');
          if (!link || link.target === '_blank') return;
          const url = new URL(link.href, location.origin);
          if (url.origin === location.origin && /\/checkout\/?$/.test(url.pathname)) { event.preventDefault(); location.assign(this.checkoutUrl()); }
        }, true);
        this.interval = setInterval(() => { this.tick(); if (Date.now() - (this.checkedAt || 0) > 60000 && !document.hidden) this.refresh(); }, 1000);
        if (!document.querySelector('libase-swipe-lp')) this.refresh();
      }
      readSaved() {
        try { return JSON.parse(localStorage.getItem(this.key) || 'null'); } catch { return null; }
      }
      valid(offer) {
        return offer?.status === 'active' && offer.scope === 'all' && offer.campaign === this.dataset.campaign && offer.percentage === 10 && /^LP[A-F0-9]{24}$/.test(offer.code || '') && /^[a-f0-9]{64}\.[a-f0-9]{64}$/.test(offer.visitorToken || '') && Number.isFinite(Date.parse(offer.expiresAt)) && Number.isFinite(Date.parse(offer.serverNow)) && Date.parse(offer.expiresAt) > Date.parse(offer.serverNow);
      }
      async receive(offer) {
        if (!document.querySelector('libase-swipe-lp[data-preview="false"][data-enabled="true"]')) return;
        if (!this.valid(offer)) { this.deactivate(); return; }
        try { localStorage.setItem(this.key, JSON.stringify({ visitorToken: offer.visitorToken })); } catch { return; }
        await this.activate(offer);
      }
      async refresh() {
        if (!this.endpoint || this.refreshing) return;
        const saved = this.readSaved();
        this.checkedAt = Date.now();
        if (!saved?.visitorToken) { this.deactivate(); return; }
        this.refreshing = true;
        try {
          const response = await fetch(`${this.endpoint.href.replace(/\/$/,'')}/status`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', cache: 'no-store', body: JSON.stringify({ visitorToken: saved.visitorToken, campaign: this.dataset.campaign }), signal: AbortSignal.timeout(10000) });
          if (!response.ok) throw new Error('Status unavailable');
          const offer = await response.json();
          if (this.readSaved()?.visitorToken !== saved.visitorToken) { this.deactivate(); return; }
          if (this.valid(offer) && offer.visitorToken === saved.visitorToken) await this.activate(offer);
          else { this.deactivate(true); if (offer.status !== 'pending') localStorage.removeItem(this.key); }
        } catch { this.deactivate(); }
        finally { this.refreshing = false; }
      }
      async activate(offer) {
        const generation = this.generation = (this.generation || 0) + 1;
        const receivedAt = performance.now();
        try {
          if (this.cartCode !== offer.code) {
            const root = this.dataset.root.replace(/\/$/,'');
            const response = await fetch(`${root}/cart/update.js`, { method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify({ discount: offer.code, sections: ['main-cart-items','main-cart-footer','cart-drawer','cart-icon-bubble'], sections_url: location.pathname }), signal: AbortSignal.timeout(10000) });
            if (!response.ok) throw new Error('Cart update unavailable');
            const cart = await response.json();
            if (this.generation !== generation) return;
            this.cartCode = offer.code;
            this.renderCart(cart.sections);
          }
          if (this.generation !== generation) return;
          if (this.readSaved()?.visitorToken !== offer.visitorToken) { this.deactivate(); return; }
          this.offer = offer;
          this.ends = Date.parse(offer.expiresAt);
          this.server = Date.parse(offer.serverNow) + performance.now() - receivedAt;
          this.monotonic = performance.now(); this.wall = Date.now(); this.checkedAt = Date.now();
          if (!this.isActive()) { this.deactivate(); return; }
          if (!this.bar) {
            this.bar = this.barTemplate.content.querySelector('[data-lp-bar]').cloneNode(true);
            this.append(this.bar);
          }
          const endLabel = this.bar.querySelector('[data-lp-end-label]');
          const endTime = new Intl.DateTimeFormat('ja-JP', { timeZone:'Asia/Tokyo', month:'numeric', day:'numeric', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' }).format(new Date(this.ends));
          endLabel.textContent = `${endTime}${endLabel.dataset.label}`;
          document.documentElement.classList.add('libase-lp-active');
          this.bar.hidden = false;
          this.renderPrices(document);
          if (!this.priceObserver) {
            this.priceObserver = new MutationObserver(records => {
              if (!this.isActive()) { this.deactivate(); return; }
              for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) this.renderPrices(node);
            });
            this.priceObserver.observe(document.body, { childList: true, subtree: true });
          }
          this.tick();
          document.dispatchEvent(new CustomEvent('libase:lp-state', { detail: offer }));
        } catch { this.deactivate(); }
      }
      renderPrices(root) {
        if (!this.isActive()) return;
        const templates = root.matches?.('template[data-lp-price-template]') ? [root] : root.querySelectorAll('template[data-lp-price-template]');
        for (const template of templates) {
          if (!template.isConnected || template.parentElement.querySelector(':scope > [data-lp-price]')) continue;
          const price = template.content.querySelector('[data-lp-price]').cloneNode(true);
          price.hidden = false;
          template.after(price);
        }
      }
      renderCart(sections) {
        if (!sections) return;
        const targets = { 'main-cart-items': '#main-cart-items', 'main-cart-footer': '#main-cart-footer', 'cart-drawer': 'cart-drawer', 'cart-icon-bubble': '#cart-icon-bubble' };
        for (const [name, selector] of Object.entries(targets)) {
          if (!sections[name]) continue;
          const current = document.querySelector(selector);
          const incoming = new DOMParser().parseFromString(sections[name], 'text/html').querySelector(selector);
          if (current && incoming && !current.contains(document.activeElement)) current.innerHTML = incoming.innerHTML;
        }
      }
      remaining() { return this.ends - this.server - Math.max(performance.now() - this.monotonic, Date.now() - this.wall); }
      isActive() { return Boolean(this.offer) && this.remaining() > 0; }
      checkoutUrl() {
        const root = this.dataset.root.replace(/\/$/,'');
        return `${root}/discount/${encodeURIComponent(this.offer.code)}?redirect=${encodeURIComponent(`${root}/checkout`)}`;
      }
      tick() {
        if (!this.offer) return;
        if (!this.isActive()) { this.deactivate(true); try { localStorage.removeItem(this.key); } catch {} return; }
        const seconds = Math.ceil(this.remaining() / 1000);
        this.querySelector('[data-lp-clock]').textContent = [Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n => String(n).padStart(2,'0')).join(':');
      }
      deactivate(refreshCart = false) {
        const previousCode = this.cartCode;
        this.generation = (this.generation || 0) + 1;
        this.offer = null;
        this.priceObserver?.disconnect(); this.priceObserver = null;
        document.documentElement.classList.remove('libase-lp-active');
        document.querySelectorAll('[data-lp-price]').forEach(price => price.remove());
        if (this.bar) { this.bar.remove(); this.bar = null; }
        document.dispatchEvent(new CustomEvent('libase:lp-state', { detail: null }));
        if (refreshCart && previousCode) {
          this.cartCode = null;
          const generation = this.generation;
          const root = this.dataset.root.replace(/\/$/,'');
          fetch(`${root}/cart/update.js`, { method: 'POST', headers: { 'Content-Type':'application/json' }, body: JSON.stringify({ updates: {}, sections: ['main-cart-items','main-cart-footer','cart-drawer','cart-icon-bubble'], sections_url: location.pathname }), signal: AbortSignal.timeout(10000) })
            .then(response => response.ok ? response.json() : null)
            .then(cart => { if (cart && this.generation === generation) this.renderCart(cart.sections); })
            .catch(() => {});
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["libase-lp-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('libase-lp-reviews')) {
    customElements.define('libase-lp-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.labels = JSON.parse(this.querySelector('[data-review-labels]').textContent);
        this.track = this.querySelector('[data-review-track]');
        this.dialog = this.querySelector('[data-review-dialog]');
        this.querySelector('[data-review-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close(); } }, { signal });
        this.toggle = this.querySelector('[data-review-toggle]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay === 'false' || this.motion.matches;
        this.cards = [];
        this.updateToggle();
        this.querySelector('[data-review-prev]').addEventListener('click', () => { this.pause(); this.go(this.index() - 1); }, { signal });
        this.querySelector('[data-review-next]').addEventListener('click', () => { this.pause(); this.go(this.index() + 1); }, { signal });
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, { signal });
        this.track.addEventListener('pointerdown', () => this.pause(), { signal });
        this.track.addEventListener('wheel', () => this.pause(), { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); event.stopPropagation(); this.pause(); this.go(this.index() + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.updateControls()); }, { passive: true, signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          if (this.visible) this.load();
          this.schedule();
        }, { root: this.closest('[data-track]'), threshold: .1 });
        this.visibility.observe(this);
        this.resize = new ResizeObserver(() => { this.updateControls(); this.fitBodies(); }); this.resize.observe(this.track);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close(); this.controller?.abort(); this.controller = null; this.visibility?.disconnect(); this.resize?.disconnect(); clearTimeout(this.timer); cancelAnimationFrame(this.frame); this.loading = false; this.loaded = false;
      }
      async load() {
        if (this.loading || this.loaded) return;
        this.loading = true;
        try {
          const response = await fetch(this.dataset.endpoint, { credentials: 'omit', signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(15000)]) });
          if (!response.ok) throw new Error('Reviews unavailable');
          const data = await response.json();
          if (data?.ok !== true || !Array.isArray(data.reviews)) throw new Error('Invalid reviews');
          const reviews = data.reviews.filter(review => review && typeof review === 'object').slice(0,20);
          if (!reviews.length) { this.message(this.labels.empty); this.loaded = true; return; }
          const fragment = document.createDocumentFragment();
          for (const review of reviews) {
            const card = this.querySelector('[data-review-card]').content.firstElementChild.cloneNode(true);
            const set = (key,value) => { card.querySelector(`[data-review-${key}]`).textContent = String(value || ''); };
            set('product',review.product_name || review.product_id);
            set('author',review.author_name || this.labels.anonymous);
            const rating = Math.max(0,Math.min(5,Number(review.rating) || 0));
            set('rating',this.stars(rating)); card.querySelector('[data-review-rating]').setAttribute('aria-label',this.labels.rating.replace('{score}',rating.toFixed(1)));
            set('title',review.title); card.querySelector('[data-review-title]').hidden = !review.title;
            set('body',review.body);
            card.querySelector('[data-review-full]').addEventListener('click', () => this.openReview(review), { signal: this.controller.signal });
            fragment.append(card);
          }
          this.track.replaceChildren(fragment); this.cards = Array.from(this.track.children);
          const avg = Number(data.summary?.avg), count = Number(data.summary?.count);
          if (Number.isFinite(avg) && avg >= 0 && avg <= 5 && Number.isInteger(count) && count > 0) {
            this.querySelector('[data-review-average]').textContent = avg.toFixed(1);
            this.querySelector('[data-review-average]').setAttribute('aria-label',this.labels.rating.replace('{score}',avg.toFixed(1)));
            this.querySelector('[data-review-stars]').textContent = this.stars(avg);
            this.querySelector('[data-review-total]').textContent = this.labels.count.replace('{count}',String(count));
            this.querySelector('[data-review-summary]').hidden = false;
          }
          this.querySelector('[data-review-message]').hidden = true;
          this.querySelector('[data-review-controls]').hidden = false; this.track.hidden = false;
          this.loaded = true; this.updateControls(); this.fitBodies(); this.schedule();
        } catch { if (!this.controller?.signal.aborted && this.isConnected) this.message(this.labels.error); }
        finally { this.loading = false; }
      }
      fitBodies() {
        for (const card of this.cards || []) {
          const body = card.querySelector('[data-review-body]');
          const lineHeight = parseFloat(getComputedStyle(body).lineHeight);
          if (lineHeight > 0) {
            const height = body.getBoundingClientRect().height;
            const lines = Math.max(1,Math.floor(height/lineHeight));
            body.style.setProperty('--llp-review-lines',String(lines));
            body.style.setProperty('--llp-review-trim',`${Math.max(0,height-lines*lineHeight)}px`);
          }
        }
      }
      openReview(review) {
        this.pause();
        const set = (key,value) => { this.dialog.querySelector(`[data-full-${key}]`).textContent = String(value || ''); };
        set('title',review.title || this.labels.full); set('author',review.author_name || this.labels.anonymous);
        set('product',review.product_name || review.product_id); set('body',review.body); set('reply',review.reply);
        this.dialog.querySelector('[data-full-reply-box]').hidden = !review.reply;
        const rating = Math.max(0,Math.min(5,Number(review.rating) || 0));
        set('rating',this.stars(rating)); this.dialog.querySelector('[data-full-rating]').setAttribute('aria-label',this.labels.rating.replace('{score}',rating.toFixed(1)));
        const date = new Date(review.created_at), time = this.dialog.querySelector('[data-full-date]');
        time.hidden = !review.created_at || !Number.isFinite(date.getTime());
        if (!time.hidden) { time.dateTime = date.toISOString(); time.textContent = new Intl.DateTimeFormat('ja-JP',{timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit'}).format(date); }
        this.dialog.showModal(); this.dialog.scrollTop = 0;
      }
      stars(rating) { const count = Math.round(rating); return '★'.repeat(count) + '☆'.repeat(5-count); }
      message(text) { const message = this.querySelector('[data-review-message]'); message.textContent = text; message.hidden = false; }
      index() {
        if (!this.cards.length) return 0;
        const left = this.track.getBoundingClientRect().left;
        return this.cards.reduce((closest,card,index) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(this.cards[closest].getBoundingClientRect().left-left) ? index : closest,0);
      }
      go(index) {
        if (!this.cards.length) return;
        index = Math.max(0,Math.min(this.cards.length-1,index));
        this.track.scrollTo({ left:this.track.scrollLeft + this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior:this.motion.matches?'instant':'smooth' });
      }
      updateControls() {
        if (!this.cards.length) return;
        this.querySelector('[data-review-position]').textContent = `${this.index()+1} / ${this.cards.length}`;
        this.querySelector('[data-review-prev]').disabled = this.track.scrollLeft <= 2;
        this.querySelector('[data-review-next]').disabled = this.track.scrollLeft >= this.track.scrollWidth-this.track.clientWidth-2;
        this.toggle.hidden = this.cards.length < 2;
      }
      pause() { this.paused = true; this.updateToggle(); clearTimeout(this.timer); }
      updateToggle() { this.toggle.textContent = this.paused ? this.labels.play : this.labels.pause; }
      schedule() {
        clearTimeout(this.timer);
        if (!this.visible || document.hidden || this.paused || this.cards.length < 2) return;
        this.timer = setTimeout(() => {
          const hovered = matchMedia('(hover: hover)').matches && this.matches(':hover');
          const focused = this.contains(document.activeElement) && document.activeElement !== this.toggle;
          if (!this.closest('[inert]') && !hovered && !focused) {
            const atEnd = this.track.scrollLeft >= this.track.scrollWidth-this.track.clientWidth-2;
            this.go(atEnd?0:this.index()+1);
          }
          this.schedule();
        },3000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
